import { BaseService } from './base.service';
import { LearningItem } from '@/models/learning-item.model';
import { Initiative } from '@/models/initiative.model';
import { Story } from '@/models/story.model';
import { EventItem } from '@/models/event-item.model';

export type Item = Initiative | Story | EventItem | LearningItem;

export interface InsightItem {
  id: number;
  type: string;
  item: Item;
}

class InsightService extends BaseService {
  private url: string = '/api';

  constructor() {
    super();
  }

  public async getListWithoutCategories(): Promise<InsightItem[]> {
    const res = await this.$http.get<InsightItem[]>(
      `${this.url}/without-category`,
    );

    return res.data;
  }

  public async updateCategories() {
    const res = await this.$http.get<any>(
      `${this.url}/update-content-categories`,
    );

    return res.data;
  }

  public async updateLocations() {
    const res = await this.$http.get<any>(
      `${this.url}/update-content-locations`,
    );

    return res.data;
  }
}

export default new InsightService();
